import { Dayjs } from 'dayjs'
import { formatAsDate } from '../config/dayjsConfig'
import sanitizeFilename from './sanitizeFilename'

type FileExtension = 'pdf' | 'xlsx' | 'csv' | 'png' | 'jpg'

export const buildReportFileName = (
  companyName: string | undefined,
  reportName: string | undefined,
  date: Dayjs | string | null | undefined,
  extension: FileExtension
): string => {
  const raw = [companyName, reportName, formatAsDate(date)].filter(Boolean).join('-')
  return sanitizeFilename(raw, 'report', extension)
}
